
 import {_backendUrl} from "../ThirdpartyConfig"
 export const backendUrl = _backendUrl;
//use the localhost url wrking on dev changes
//export const backendUrl = "http://localhost:3001" ;             
